import { render, staticRenderFns } from "./MadMixScreen.vue?vue&type=template&id=60b710f5&scoped=true"
import script from "./MadMixScreen.vue?vue&type=script&lang=js"
export * from "./MadMixScreen.vue?vue&type=script&lang=js"
import style0 from "./MadMixScreen.vue?vue&type=style&index=0&id=60b710f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b710f5",
  null
  
)

export default component.exports